import React from "react";
import ModalAlt from "../../../components/modal/ModalAlt";
import Container from "../../Container";
import BottomDrawer from "./BottomDrawer";

const DrawerAndModalWrapper = ({
    isOpen,
    onClose,
    children,
    modalContentClass,
    drawerContentClassName = "min-h-[60vh] bg-white rounded-t-4",
    drawerClassName,
}) => {
    return (
        <div>
            <div className="hidden lg:block">
                <ModalAlt
                    isOpen={isOpen}
                    backgroundColor="transparent"
                    contentClass={modalContentClass}
                    onClose={onClose}
                    innerTimes={false}
                    topPadding={"3px"}
                    overlayClass="flex items-center h-screen max-h-auto pt-0"
                >
                    {children}
                </ModalAlt>
            </div>
            <div className="block lg:hidden">
                <BottomDrawer
                    isOpen={isOpen}
                    onClick={onClose}
                    contentClass={drawerContentClassName}
                    childrenClassName="bg-white"
                    className={drawerClassName}
                >
                    <Container className="pb-6.4">{children}</Container>
                </BottomDrawer>
            </div>
        </div>
    );
};

export default DrawerAndModalWrapper;
